export enum CountryDataStatus {
    Draft = 1,
    Superseded = 3,
    Live = 4
}